export const manifest = {
  screens: {
    scr_1crz8q: { name: "Home", route: "/", position: {"x":160,"y":3800} },
    scr_hgsp31: { name: "Quiz — What are you looking for?", route: "/", state: {"step":1}, position: {"x":160,"y":1820} },
    scr_8kmng1: { name: "Quiz — Neighborhood", route: "/", state: {"step":2}, position: {"x":1560,"y":1820} },
    scr_2ufpp7: { name: "Quiz — Bringing people", route: "/", state: {"step":3}, position: {"x":4360,"y":1820} },
    scr_qr1uiu: { name: "Quiz — How far along", route: "/", state: {"step":4}, position: {"x":5760,"y":1820} },
    scr_r6f3ks: { name: "Quiz — Name & email", route: "/", state: {"step":5}, position: {"x":8560,"y":1820} },
    scr_so1rcm: { name: "Quiz — Confirmation", route: "/", state: {"step":6}, position: {"x":9960,"y":1820} },
    scr_x3clzf: { name: "Events", route: "/events", position: {"x":1560,"y":3800} },
  },
  sections: {
    sec_jgcasv: { name: "Quiz flow", x: 0, y: 1600, width: 11320, height: 1180 },
    sec_pc56qi: { name: "Main navigation", x: 0, y: 3580, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_jgcasv", children: [
      { kind: "screen", id: "scr_hgsp31" },
      { kind: "screen", id: "scr_8kmng1" },
      { kind: "screen", id: "scr_2ufpp7" },
      { kind: "screen", id: "scr_qr1uiu" },
      { kind: "screen", id: "scr_r6f3ks" },
      { kind: "screen", id: "scr_so1rcm" },
    ] },
    { kind: "section", id: "sec_pc56qi", children: [
      { kind: "screen", id: "scr_1crz8q" },
      { kind: "screen", id: "scr_x3clzf" },
    ] },
  ],
}
